import { Component, Input, OnInit } from '@angular/core';
import { LanguageService, StorageService, TempKey } from '@services/public';
import { BRAIN_PAGE, BrainData } from '../common';
import { ReplaySubject } from 'rxjs';
import { SelectListNext, SelectListOption } from '@components';

const PAGE_PATH: string = 'skillBuilders.brain.pages.yesterday';

@Component({
	selector: 'app-member-skill-builder-brain-yesterday',
	templateUrl: './yesterday.component.html',
	styleUrls: ['./yesterday.component.scss'],
})
export class MemberSkillBuilderBrainYesterdayComponent implements OnInit {
	@Input() data: BrainData;
	options: ReplaySubject<Array<SelectListOption>> = new ReplaySubject<
		Array<SelectListOption>
	>(1);
	next: SelectListNext = {
		onClick: this.nextOnClick.bind(this),
	};

	// Page langauge.
	page: { [key: string]: string } = {
		title: '',
		subTitle: '',
		yesterday: '',
		today: '',
	};

	constructor(
		private _languageSvc: LanguageService,
		private _storageSvc: StorageService,
	) {}

	async ngOnInit(): Promise<void> {
		// Get page language.
		await this._languageSvc.get([PAGE_PATH]).then((value) => {
			if (typeof value[PAGE_PATH] === 'object' && value[PAGE_PATH] !== null)
				this.page = value[PAGE_PATH];
		});

		// Get the options list.
		this.options.next([
			{
				display: this.page.yesterday,
				value: true,
			},
			{
				display: this.page.today,
				value: false,
			},
		]);
	}

	nextOnClick(option: SelectListOption): void {
		this._storageSvc.setTempStorage(TempKey.BRAIN, {
			...this.data,
			page: BRAIN_PAGE.AFFIRMATIONS,
			yesterday: option.value,
		});
	}
}
